module.exports = __webpack_public_path__ + "static/media/man-laptop-v1.03656e6b.svg";